import { useNavigate, useLocation } from 'react-router-dom';
import { Dashicon } from '@wordpress/components';
import { useLayouts } from "./LayoutsProvider";
import {__} from '@wordpress/i18n';

const CanvasHeader = () => {
    const { loading, layouts } = useLayouts();
    const navigate             = useNavigate();
    const location             = useLocation();
    let heading                = '';
    const headerLayouts        = layouts.filter(current => current.layout_value === 'header');
    const footerLayouts        = layouts.filter(current => current.layout_value === 'footer');
    const notFoundLayouts      = layouts.filter(current => current.layout_value === '404-page');
    let displayCreateNewBtn    = false;

    if ( layouts.length > 0 && location.pathname === '/' ) {
        heading = __( 'All Layouts', 'responsive-addons' );
        displayCreateNewBtn = true;
    } else if ( location.pathname === '/header' ) {
        heading = __( 'Header', 'responsive-addons' );
        headerLayouts.length > 0 ? displayCreateNewBtn = true : null;
    } else if ( location.pathname === '/footer' ) {
        heading = __( 'Footer', 'responsive-addons' );
        footerLayouts.length > 0 ? displayCreateNewBtn = true : null;
    } else if ( location.pathname === '/404' ) {
        heading = '404';
        notFoundLayouts.length > 0 ? displayCreateNewBtn = true : null;
    } else {
        heading = __( 'Start Customizing Every Section of Your Website.', 'responsive-addons' );
    }

    const newPostType = heading === '404' ? '404-page' : heading.toLowerCase();
    const newPostLink = responsive_addons_site_builder?.admin_url + 'post-new.php?post_type=resp-site-builder&type=' + newPostType;

    return (
        <div className="flex items-center justify-between pb-4 border-b-[1px] border-border">
            <h2 className="text-xl font-semibold text-black">{heading}</h2>
            { displayCreateNewBtn &&
                <button onClick={() => location.pathname === '/' || location.pathname === '/new' ? navigate('/new') : window.location.href = newPostLink } className="flex gap-2 pr-[14px] pl-[14px] py-2 text-white bg-btnPrimary hover:bg-sky-600 rounded">
                    <Dashicon icon="plus-alt2" />
                    {__( 'Create New', 'responsive-addons' )}
                </button>
            }
        </div>
    )
}

export default CanvasHeader